import { useSearchParams } from 'react-router-dom'
import WeekOverview from './../../shift_management/week_overview'
import { Select } from '../../ui/ot'
import { useCRUDController } from '../../ui/classify_structure/CRUDController'
import { useEffect } from 'react'
import { useState } from 'react'
import { useRef } from 'react'
const WeekManagement = ({
    keyPrefix = "reservation_registration_and_space_management.week_management",
}) => {
    const [searchParams] = useSearchParams()
    const { schedule_id } = Object.fromEntries([...searchParams])
    const scheudleIdRef = useRef(schedule_id)
    const scheduleController = useCRUDController({
        apiRoute: '/reservation_registration_and_space_management/schedule'
    })
    useEffect(() => {
        scheduleController.getData({})
    }, [scheudleIdRef.current])
    return <>
        <WeekOverview
            key={scheudleIdRef.current}
            propsApiRoute='/reservation_registration_and_space_management/week'
            propsExtraParams={{
                schedule_id_arr: [scheudleIdRef.current],
            }}
            propsParsedBody={{
                schedule_class_data:[
                    {
                        schedule_id:scheudleIdRef.current
                    }
                ]
            }}
        />
    </>
}
export default WeekManagement